import {
 ActionLog,
 AddRevision,
 AllSelected,
 ApValue,
 BlockingTimes,
 BusFile,
 Cameras,
 CheckDeviceState,
 Configuration,
 ConfigurationData,
 ConnectionQuality,
 CountValueData,
 CounterValue,
 DefineRoute,
 Detector,
 DeviceCommunicationError,
 DeviceError,
 DeviceNotControl,
 DeviceSetting,
 Devices,
 EditMessageGroup,
 EditMessages,
 EditRoute,
 FacilitySearch,
 FetchCounterValue,
 FetchPtData,
 GreenWaveDisplay,
 GreenWaves,
 Help,
 Identity,
 IntersectionState,
 Lamp,
 Login,
 MacroControl,
 MacroData,
 MaintenanceInfo,
 Map,
 MessageGroup,
 MessageReceipt,
 MessageSimulation,
 Modification,
 Module,
 News,
 Password,
 DeviceGroups,
 Position,
 PtChain,
 PtData,
 PtLine,
 PtPoints,
 Revision,
 RouteColor,
 RsuTest,
 SelectedDevice,
 SignalGroup,
 SignalPlan,
 SignalSchedule,
 SignalTimingRecording,
 SitePlan,
 StateColor,
 Streets,
 SubInterSection,
 Switch,
 SystemMessagesPage,
 TaskElement,
 TimeDifference,
 TimeDomain,
 TimeMechanism,
 TrafficSign,
 UserLog,
 UserLogin,
 UserManagement,
 PlantData,
 EditSitePlan,
 SitePlanDevices,
 GreenWaveDisplayGraph,
 DashBoard,
 MessageTable,
 PageNotFound,
 PlantStatus,
} from "Pages"

import { PrivateRoute, UnAuthRoute } from "components"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { BrowserRouter, Route, Routes } from "react-router-dom"
function App() {
 const { i18n } = useTranslation("translation")
 const languages: string[] = ["en", "gr"]
 useEffect(() => {
  if (!languages.includes(i18n.language)) i18n.changeLanguage("gr")
  // eslint-disable-next-line
 }, [i18n])

 return (
  <BrowserRouter>
   <Routes>
    <Route path="/" element={<PrivateRoute />}>
     <Route path="/" element={<DashBoard />} />
     <Route path="/signal-timing-recording" element={<SignalTimingRecording />} />
     <Route path="/switch" element={<Switch />} />
     <Route path="/revisions" element={<Revision />} />
     <Route path="/plant-status" element={<PlantStatus />} />
     <Route path="/signal-groups" element={<SignalGroup />} />
     <Route path="/all-selected" element={<AllSelected />} />
     <Route path="/selected" element={<SelectedDevice />} />
     <Route path="/device-error" element={<DeviceError />} />
     <Route path="/device-not-controlled" element={<DeviceNotControl />} />
     <Route path="/device-communication-error" element={<DeviceCommunicationError />} />
     <Route path="/task-element" element={<TaskElement />} />
     <Route path="/pt-points" element={<PtPoints />} />
     <Route path="/map" element={<Map />} />
     <Route path="/cameras" element={<Cameras />} />
     <Route path="/edit-messages" element={<EditMessages />} />
     <Route path="/message-groups" element={<EditMessageGroup />} />
     <Route path="/traffic-signs" element={<TrafficSign />} />
     <Route path="/configuration-data" element={<ConfigurationData />} />
     <Route path="/maintenance-info" element={<MaintenanceInfo />} />
     <Route path="/intersection-state" element={<IntersectionState />} />
     <Route path="/signal-schedule" element={<SignalSchedule />} />
     <Route path="/green-wave-display" element={<GreenWaveDisplay />} />
     <Route path="/macro-data" element={<MacroData />} />
     <Route path="/query-system" element={<CheckDeviceState />} />
     <Route path="/fetch-pt-data" element={<FetchPtData />} />
     <Route path="/fetch-counter-values" element={<FetchCounterValue />} />
     <Route path="/userLogin" element={<UserLogin />} />
     <Route path="/signal-plan" element={<SignalPlan />} />
     <Route path="/news" element={<News />} />
     <Route path="/devices" element={<Devices />} />
     <Route path="/position" element={<Position />} />
     <Route path="/lamps" element={<Lamp />} />
     <Route path="/pt-lines" element={<PtLine />} />
     <Route path="/modifications" element={<Modification />} />
     <Route path="/streets" element={<Streets />} />
     <Route path="/subInterSection" element={<SubInterSection />} />
     <Route path="/state-colors" element={<StateColor />} />
     <Route path="/edit-routes" element={<EditRoute />} />
     <Route path="/message-receipt" element={<MessageReceipt />} />
     <Route path="/green-waves" element={<GreenWaves />} />
     <Route path="/macro-control" element={<MacroControl />} />
     <Route path="/message-groups" element={<MessageGroup />} />
     <Route path="/pt-chains" element={<PtChain />} />
     <Route path="/bus-files" element={<BusFile />} />
     <Route path="/route-colors" element={<RouteColor />} />
     <Route path="/define-routes" element={<DefineRoute />} />
     <Route path="/count-value-data" element={<CountValueData />} />
     <Route path="/help" element={<Help />} />
     <Route path="/counter-values" element={<CounterValue />} />
     <Route path="/connection-quality" element={<ConnectionQuality />} />
     <Route path="/action-log" element={<ActionLog />} />
     <Route path="/user-management" element={<UserManagement />} />
     <Route path="/message-simulation" element={<MessageSimulation />} />
     <Route path="/module" element={<Module />} />
     <Route path="/pt-data" element={<PtData />} />
     <Route path="/System-messages" element={<SystemMessagesPage />} />
     <Route path="/time-differences" element={<TimeDifference />} />
     <Route path="/user-log" element={<UserLog />} />
     <Route path="/green-and-red-time" element={<BlockingTimes />} />
     <Route path="/device-groups" element={<DeviceGroups />} />
     <Route path="/detectors" element={<Detector />} />
     <Route path="/ap-values" element={<ApValue />} />
     <Route path="/sitePlan" element={<SitePlan />} />
     <Route path="/search" element={<FacilitySearch />} />
     <Route path="/addRevision" element={<AddRevision />} />
     <Route path="/time-domain" element={<TimeDomain />} />
     <Route path="/time-mechanism" element={<TimeMechanism />} />
     <Route path="/configuration" element={<Configuration />} />
     <Route path="/identity" element={<Identity />} />
     <Route path="/password" element={<Password />} />
     <Route path="/device-settings" element={<DeviceSetting />} />
     <Route path="/rsu-test" element={<RsuTest />} />
     <Route path="/messages" element={<MessageTable />} />
     <Route path="/edit-site-plan" element={<EditSitePlan />} />
     <Route path="/plant-data" element={<PlantData />} />
     <Route path="/site-plan-devices" element={<SitePlanDevices />} />
     <Route path="/green-wave-display-graph" element={<GreenWaveDisplayGraph />} />
    </Route>
    <Route path="/" element={<UnAuthRoute />}>
     <Route path="/login" element={<Login />} />
    </Route>
    <Route path="*" element={<PageNotFound />} />
   </Routes>
  </BrowserRouter>
 )
}

export default App
